export type ABO = 'O' | 'A' | 'B' | 'AB';

type ABOMap = Record<ABO, Record<ABO, ABO[]>>;

const ABO_COMPATIBILITY: ABOMap = {
    O: {
        O: ['O'],
        A: ['A', 'O'],
        B: ['B', 'O'],
        AB: ['A', 'B'],
    },

    A: {
        O: ['A', 'O'],
        A: ['A', 'O'],
        B: ['A', 'B', 'O', 'AB'],
        AB: ['A', 'B', 'AB'],
    },

    B: {
        O: ['B', 'O'],
        A: ['A', 'B', 'O', 'AB'],
        B: ['B', 'O'],
        AB: ['A', 'B', 'AB'],
    },

    AB: {
        O: ['O', 'A', 'B', 'AB'],
        A: ['O', 'A', 'B', 'AB'],
        B: ['O', 'A', 'B', 'AB'],
        AB: ['O', 'A', 'B', 'AB'],
    },
};

export function getAllowedDonorABO(
    recipientABO: ABO,
    fatherABO?: ABO
): ABO[] {

    // Pai conhecido → lookup direto
    if (fatherABO) {
        return ABO_COMPATIBILITY[recipientABO][fatherABO];
    }

    // Pai desconhecido → união de todos os cenários possíveis
    const allPossibilities = Object.values(
        ABO_COMPATIBILITY[recipientABO]
    ).flat();

    // Remove duplicados mantendo tipagem
    return Array.from(new Set(allPossibilities));
}


export const getAllowedRhFactor = (rhFactorMother: string): Array<string> => {
    if (rhFactorMother === "P") {
        return ["P", "N"];
    } else {
        return ["N"];
    }
}